/**
 * adminFetch - shared HTTP helper for `/api/admin/*` endpoints.
 *
 * Extracted from UsersSection so TeamsSection (and future admin panels) do not
 * duplicate the same fetch/error-unwrap/204 handling. Same cookie rules as the
 * rest of the app: `credentials: "include"`.
 */
export const adminFetch = async <T>(url: string, init?: RequestInit): Promise<T> => {
  const response = await fetch(url, {
    credentials: "include",
    headers: { "Content-Type": "application/json", ...init?.headers },
    ...init,
  });
  if (!response.ok) {
    let message = `${response.status} ${response.statusText}`;
    try {
      const body = (await response.json()) as { error?: string };
      if (body.error) message = body.error;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }
  if (response.status === 204) return undefined as unknown as T;
  return (await response.json()) as T;
};
